import React, { useState, useEffect } from 'react';
import Main from '../Componentes/Main';
import { Link } from 'react-router-dom';
import Loading from '../Componentes/Loading';
import Avatar from '../Componentes/Avatar';
import Comentar from '../Componentes/Comentar';
import BotonLike from '../Componentes/BotonLike';
import RecursoNoExiste from '../Componentes/RecursoNoExiste';

import useLike from '../Hooks/useLike';
import useComentar from '../Hooks/useComentar';

import { useError } from '../Context/Error';

import Axios from 'axios';

export default function Post({ match }) {
  const id = match.params.id;
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enviandoLike, setEnviandoLike] = useState(false);
  const [postNoExiste, setPostNoExiste] = useState(false);
  const toggleLike = useLike();
  const comentar = useComentar();
  const { showError } = useError();

  useEffect(() => {
    async function cargarPost() {
      try {
        const { data: post } = await Axios.get(`/api/posts/${id}`);
        setPost(post);
        setLoading(false);
      } catch (error) {
        console.log(error);
        if (
          error.response &&
          (error.response.status === 404 || error.response.status === 400)
        ) {
          setPostNoExiste(true);
        } else {
          showError('Hubo un problema cargando este post.');
        }
        setLoading(false);
      }
    }

    cargarPost();
  }, [id]);

  async function onSubmitComentario(comentario) {
    const postConComentario = await comentar(post, comentario);
    setPost({ ...postConComentario });
  }

  async function onSubmitLike() {
    if (enviandoLike) {
      return;
    }

    try {
      setEnviandoLike(true);
      const postConLike = await toggleLike(post);
      setPost({ ...postConLike });
      setEnviandoLike(false);
    } catch (e) {
      setEnviandoLike(false);
      showError('Hubo un problema modificando el like. Intenta de nuevo.');
      console.log(e);
    }
  }

  if (loading) {
    return (
      <Main center>
        <Loading />
      </Main>
    );
  }

  if (postNoExiste) {
    return (
      <RecursoNoExiste mensaje="El post que estas intentando ver no existe" />
    );
  }

  if (post == null) {
    return null;
  }

  return (
    <Main>
      <PostSideView
        onSubmitComentario={onSubmitComentario}
        onSubmitLike={onSubmitLike}
        {...post}
      />
    </Main>
  );
}

function PostSideView({
  comentarios,
  caption,
  url,
  usuario,
  estaLike,
  onSubmitLike,
  onSubmitComentario
}) {
  return (
    <div className="Post">
      <div className="Post__image-container">
        <img src={url} alt="" />
      </div>
      <div className="Post__side-bar">
        <Avatar usuario={usuario} />

        <div className="Post__comentarios-y-like">
          <Comentarios
            usuario={usuario}
            caption={caption}
            comentarios={comentarios}
          />
          <div className="Post__like">
            <BotonLike onSubmitLike={onSubmitLike} like={estaLike} />
          </div>
          <Comentar onSubmitComentario={onSubmitComentario} />
        </div>
      </div>
    </div>
  );
}

function Comentarios({ usuario, caption, comentarios }) {
  return (
    <ul className="Post__comentarios">
      <li className="Post__comentario">
        <Link
          className="Post__autor-comentario"
          to={`/perfil/${usuario.username}`}
        >
          <b>{usuario.username}</b> {caption}
        </Link>
      </li>
      {comentarios.map((comentario, index) => (
        <li className="Post__comentario" key={index}>
          <Link
            className="Post__autor-comentario"
            to={`/perfil/${comentario.usuario.username}`}
          >
            <b>{comentario.usuario.username}</b>
          </Link>{' '}
          {comentario.mensaje}
        </li>
      ))}
    </ul>
  );
}
